<template>
  <div id="publishContent">
    <div class="publishPreviewNav">
      <img src="../../../../img/logo.png" alt="" />
      <span class="publishNavTitle">大百科</span>
    </div>
    <!-- 页面标题 -->
    <div class="contentBox">
      <div class="subBranch">{{ subBranch }}</div>
      <div class="articleTitleBox clearfix">
        <!-- <p> -->
        <p class="itemTitle fl" v-html="articleTitle"></p>
        <p hidden ref="enName" class="enName"></p>
        <p class="englishTitle fl"></p>
        <!-- </p> -->
        <div class="authorBox fr">
          <span class="i-author">词条作者</span>
          <span class="n-author mul-author">
            <span
              v-for="(item, index) in authorList"
              :key="index"
              class="author-span"
              >{{ item.authorName }}</span
            >
          </span>
        </div>
      </div>
      <el-row class="timeHitsBox">
        <el-col :xs="24" :sm="11" :md="9" :lg="7" :xl="5" class="modifyTime">
          <i class="el-icon-timer" style="margin-right: 5px"></i>
          <span>添加时间：{{ modifyTime }}</span>
        </el-col>
        <el-col :xs="24" :sm="5" :md="5" :lg="4" :xl="4" class="hits">
          <i class="el-icon-view" style="margin-right: 5px"></i>
          <span>点击量：{{ hits }}</span>
        </el-col>
        <el-col :xs="24" :sm="8" :md="10" :lg="13" :xl="15" class="fontButton">
          <span class="pointer enlarge" @click="fontLarge()"></span>
          <span class="pointer narrow" @click="fontNarrow()"></span>
        </el-col>
      </el-row>
      
    <div id="adBox" v-if="adverInfo.type == 10">
      <a :href="adverInfo.link"><img :src="adverInfo.logo" :alt="adverInfo.linkContent"></a>
      <!-- <span @click="closeAdver()">
        <i class="el-icon-close"></i>
        关闭
      </span> -->
    </div>

      <div class="descText fontsize">
        <div hidden class="descTextContent"></div>
        <div class="descTextBox">
          <p class="descContent" v-if="!descImgFlag"></p>
          <div class="descImgContent" v-if="descImgFlag">
            <el-row>
              <el-col class="descImg" :md="5" :lg="5"> </el-col>
              <el-col :md="19" :lg="19" style="padding-left: 20px">
                <div class="descMainContent" style="margin-bottom: 20px"></div>
                <div class="summaryFields">
                  <div class="infoText">
                    <el-col
                      :span="12"
                      v-for="(item, index) in headTextList"
                      :key="index"
                    >
                      <p class="summaryName fontsize">{{ item.name }}</p>
                      <p class="summaryValue fontsize">{{ item.value }}</p>
                    </el-col>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <div class="summaryFields" v-if="!descImgFlag">
        <div class="infoText">
          <el-col :span="12" v-for="(item, index) in headTextList" :key="index">
            <p class="summaryName fontsize">{{ item.name }}</p>
            <p class="summaryValue fontsize" v-html="item.value"></p>
          </el-col>
        </div>
      </div>

      <div class="mainContent fontsize adv-content">
        <!-- <div class="moduleTitle">正文</div> -->
        <div class="previewContent"></div>
      </div>
      <div class="opusContent fontsize">
        <div class="moduleTitle">著作</div>
        <ul class="opusList"></ul>
      </div>
      <div class="refContent fontsize">
        <div class="moduleTitle">引文</div>
        <ul class="refList"></ul>
      </div>
      <div class="chronologyContent fontsize">
        <div class="moduleTitle">大事年表</div>
        <ul class="chronologyList" v-if="chronologyList.length>0">
          <li v-for="item in chronologyList" :key="item.sorder">
            <div class="chronologyItemTitle">
              {{ item.sbeginTime }}
            </div>
            <div v-html="item.sText"  class="chronologyItemContent"></div>
          </li>
        </ul>
      </div>
      <div class="extendContent fontsize">
        <div class="moduleTitle">扩展阅读</div>
        <ul class="extendList"></ul>
      </div>
      <div class="otherExtendContent">
        <div class="moduleTitle">扩展内容</div>
        <ul class="otherExtendList"></ul>
      </div>
    </div>

    <!-- 广告部分 -->
    <div id="adBox" v-if="adFlag">
      <img src="https://ai.bkzx.cn/zyk/resource/upload/image/banner.jpg" alt="">
      <!-- <span @click="adFlag = false">
        <i class="el-icon-close"></i>
        关闭广告
      </span> -->
    </div>

    <!-- 正式广告展示部分 -->
    <div id="adBox" v-if="adverInfo.type == 30">
      <a :href="adverInfo.link"><img :src="adverInfo.path" alt=""></a>
      <!-- <span @click="closeAdver()">
        <i class="el-icon-close"></i>
        关闭广告
      </span> -->
    </div>
    <div id="adSide" v-if="adverInfo.type == 20">
      <a :href="adverInfo.link"><img :src="adverInfo.path" alt=""></a>
      <!-- <span @click="closeAdver()">
        <i class="el-icon-close"></i>
        关闭广告
      </span> -->
    </div>

    <!-- 页面目录 -->
    <div class="menuBox rt-panel">
      <div style="height: 100%; overflow: scroll">
        <div class="nav-title"><i class="el-icon-menu"></i>目录</div>
        <ul class="catalogue-box">
          <li
            v-for="(item, index) in catalogue"
            :key="index"
            :class="'catalogue' + item.level"
            :id="'menu' + item.id"
          >
            <a @click="menuClick(item)"
              ><span>{{ item.title }}</span>
            </a>
          </li>
        </ul>
        <el-button
          class="menuButton"
          icon="el-icon-notebook-2"
          @click="closeSide()"
        ></el-button>
      </div>
    </div>

    <div class="publishFooter">
      <div class="footerContent">
        <p>版权所有 © 北京百科在线文化传媒有限公司</p>
        <p>京ICP备12000488号-2</p>
      </div>
    </div>

    <!-- 打开图片 -->
    <div class="picLarge" hidden>
      <el-button icon="el-icon-close" @click="picLargeClose"></el-button>
      <img src="" />
      <!-- <div class="swiper-container">
        <swiper :options="swiperOptions" ref="mySwiper">
          轮播项
          <swiper-slide v-for="(item, index) in swiperImages" :key="index">
            <img :src="item.httpPath" class="slide-image" alt="轮播图" />
          </swiper-slide>

          分页器
          <div class="swiper-pagination" slot="pagination"></div>

          导航按钮
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
// import Swiper from "swiper";
import "swiper/css/swiper.min.css";

// import "@/assets/css/viewer.min.css";
// import "@/assets/js/viewer-jquery.min.js";
export default {
  data() {
    return {
      data: [],
      articleTitle: "",
      englishTitle: "",
      authorText: "",
      sourceInfo: "",
      descText: "",
      subBranch: "",
      securityLevel: 10,
      headTextList: [],
      summaryFieldsList: [],
      refText: [],
      catalogue: [],
      scrollDistance: 0,
      opusData: [],
      chronologyList: [],
      modifyTime: "",
      hits: "",
      authorList: [],
      descImgFlag: false,
      // 轮播图
      swiperImages: [],
      // Swiper 配置项
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true,
        observeParents: true,
        on: {
          observerUpdate: function () {
            console.log("监测到Swiper 更新了");
          },
        },
      },
      adFlag:false,
      adverInfo:{},
    };
  },
  props: {
    topIndex: String,
  },
  computed: {
    // 获取 Swiper 实例
  },
  mounted() {
    window.addEventListener("scroll", this.updateScrollDistance);
    var param = {}
    
    var url = ""
    if (this.$route.query.id) {
      url = "/zyk/webapi/free/word/detail"
      param={ wordId: this.$route.query.id }
    }else if(this.$route.query.name) {
      url = "/zyk/webapi/free/word/detailByName"
      param={ 
        name: this.$route.query.name,
        sourceId: this.$route.query.sourceId,
      }
    }
    // else if(this.$route.query.innercode) {
    //   url = "/zyk/webapi/free/word/detailByName"
    //   param={ 
    //     name: this.$route.query.name,
    //     innercode: this.$route.query.innercode,
    //   }
    // }else if(this.$route.query.code) {
    //   url = "/zyk/webapi/free/word/detailByName"
    //   param={ 
    //     name: this.$route.query.name,
    //     code: this.$route.query.code,
    //   }
    // }
    
    let that = this;
    $.ajax({
      type: "GET",
      dataType: "json",
      url: url,
      data: param,
      contentType: "application/json;charset=utf-8",
      success: function (response) {
        if (response.code == 200) {
          var data = response.obj;

          // 判断是否显示广告内容
          var adArray = [8581200,8506788]
          that.adFlag = adArray.includes(data.id)   
          
          if(data.adverInfo){
            that.adverInfo = data.adverInfo
          }

          if (data.headText != "[]") {
            that.headTextList = JSON.parse(data.headText);
            if (
              that.headTextList.filter((item) => item.name == "英文名称")
                .length > 0
            ) {
              that.englishTitle = that.headTextList.filter(
                (item) => item.name == "英文名称"
              )[0].value;
            }
            $(".enName").html(that.englishTitle);
            if ($(".enName").text() != "") {
              $(".englishTitle").text("/" + $(".enName").text() + "/");
            }
          }
          if (data.authorText != "[]") {
            that.authorText = JSON.parse(data.authorText)[0].authorName;
          } else {
            $(".authorBox").hide();
          }
          // 处理大事年表
          if (data.chronologyText && data.chronologyText != "{}" && data.chronologyText != "[]") {
            that.chronologyList = JSON.parse(data.chronologyText).list;
          } else {
            $(".chronologyContent").hide();
          }
          
          if(data.subBranch){
            that.subBranch = data.subBranch.replace(/\//g, " . ");
          }

          if (data.summaryFields != "[]") {
            that.summaryFieldsList = JSON.parse(data.summaryFields);
          }
          $.merge(that.headTextList, that.summaryFieldsList);
          // 处理定性语
          if (data.descText != "") {
            that.descText = data.descText;
            $(".descTextContent").html(data.descText);
            if ($(".descTextContent").find("img").length != 0) {
              that.descImgFlag = true;
              setTimeout(function () {
                $(".descImg").html($(".descTextContent").find("img")[0]);
                $(".descMainContent").html(
                  $(".descTextContent p:not(:has(img))")
                );
              }, 500);
            } else {
              that.descImgFlag = false;
              $(".descContent").html(data.descText);
            }
          }

          if (that.headTextList.length > 0) {
            that.headTextList = that.headTextList.filter(
              (item) =>
                item.value != "" &&
                item.value != "<br>" &&
                item.name != "拼音条头"
            );
          }

          that.articleTitle = data.name;
          that.hits = data.hits;
          that.authorList = JSON.parse(data.authorText);
          document.title = data.name + "-大百科";

          // 处理著作
          if (data.opusText != "[]") {
            var opusData = JSON.parse(data.opusText);
            that.opusData = JSON.parse(data.opusText);
            var opusHtml = "";
            for (var i = 0; i < opusData.length; i++) {
              opusHtml += "<li>";
              if (opusData[i].mainPerson != undefined) {
                opusHtml += opusData[i].mainPerson + " . ";
              }
              if (opusData[i].bookName != undefined) {
                opusHtml += opusData[i].bookName + " . ";
              }
              if (opusData[i].publishAddress != undefined) {
                opusHtml += opusData[i].publishAddress + " : ";
              }
              if (opusData[i].publishauthor != undefined) {
                opusHtml += opusData[i].publishauthor + " . ";
              }
              if (opusData[i].publishYear != undefined) {
                opusHtml += opusData[i].publishYear + " . ";
              }
              opusHtml += "</li>";
            }
            $(".opusContent .opusList").html(opusHtml);
          } else {
            $(".opusContent").hide();
          }

          // 处理otherText内容
          if (data.otherText != "[]" && data.otherText != null) {
            var otherData = JSON.parse(data.otherText),
              otherHtml = "";
            otherData.forEach((item) => {
              otherHtml += "<li>" + item + "</li>";
            });
            $(".otherExtendContent .otherExtendList").html(otherHtml);
          } else {
            $(".otherExtendContent").hide();
          }

          // 处理引文
          if (data.refText != "[]") {
            var refData = JSON.parse(data.refText);
            var isEmpty = refData.every((item) => item.list.length == 0);
            if (isEmpty) {
              $(".refContent").hide();
            }else{
              var refHtml = "";
              for (var j = 0; j < refData.length; j++) {
                if (refData[j].type == "1") {
                  var ref1Data = refData[j].list;
                  for (var k = 0; k < ref1Data.length; k++) {
                    refHtml += "<li>";
                    if (ref1Data[k].mainPerson != undefined) {
                      refHtml += ref1Data[k].mainPerson + " . ";
                    }
                    if (ref1Data[k].bookName != undefined) {
                      refHtml += ref1Data[k].bookName + " . ";
                    }
                    if (ref1Data[k].publishAddress != undefined) {
                      refHtml += ref1Data[k].publishAddress + " : ";
                    }
                    if (ref1Data[k].publishauthor != undefined) {
                      refHtml += ref1Data[k].publishauthor + " . ";
                    }
                    if (ref1Data[k].publishYear != undefined) {
                      refHtml += ref1Data[k].publishYear + " . ";
                    }
                    refHtml += "</li>";
                  }
                } else if (refData[j].type == "2") {
                  var ref2Data = refData[j].list;
                  for (var l = 0; l < ref2Data.length; l++) {
                    refHtml += "<li>";
                    if (ref2Data[l].linkAddress != undefined) {
                      refHtml +=
                        "<a href='" +
                        ref2Data[l].linkAddress +
                        "' target='_blank'>";
                    }
                    if (ref2Data[l].mainPerson != undefined) {
                      refHtml += ref2Data[l].mainPerson + " . ";
                    }
                    if (ref2Data[l].bookName != undefined) {
                      refHtml += ref2Data[l].bookName + " . ";
                    }
                    if (ref2Data[l].linkAddress != undefined) {
                      refHtml += "</a>";
                    }
                    if (ref2Data[l].bookNameL != undefined) {
                      refHtml += ref2Data[l].bookNameL + " , ";
                    }
                    if (ref2Data[l].publishYear != undefined) {
                      refHtml += ref2Data[l].publishYear + " . ";
                    }
                    if (ref2Data[l].Volume != undefined) {
                      refHtml += ref2Data[l].Volume + " . ";
                    }
                    if (ref2Data[l].pageNumber != undefined) {
                      refHtml += ref2Data[l].pageNumber + " . ";
                    }
                    refHtml += "</li>";
                  }
                }
              }
              $(".refContent .refList").html(refHtml);
            }
          } else {
            $(".refContent").hide();
          }

          // 处理扩展阅读
          if (data.extendText != "[]") {
            var extendData = JSON.parse(data.extendText);
            var extendHtml = "";
            for (var m = 0; m < extendData.length; m++) {
              if (extendData[m].type == "1") {
                var extend1Data = extendData[m].list;
                for (var p = 0; p < extend1Data.length; p++) {
                  extendHtml += "<li>";
                  if (extend1Data[p].linkAddress != undefined) {
                    extendHtml +=
                      "<a href='" +
                      extend1Data[p].linkAddress +
                      "' target='_blank'>";
                  }
                  if (extend1Data[p].leaders != undefined) {
                    extendHtml += extend1Data[p].leaders + " . ";
                  }
                  if (extend1Data[p].speechName != undefined) {
                    extendHtml += extend1Data[p].speechName + " . ";
                  }
                  if (extend1Data[p].linkAddress != undefined) {
                    extendHtml += "</a>";
                  }
                  extendHtml += "</li>";
                }
              } else if (extendData[m].type == "2") {
                var extend2Data = extendData[m].list;
                for (var q = 0; q < extend2Data.length; q++) {
                  extendHtml += "<li>";
                  if (extend2Data[q].mainPerson != undefined) {
                    extendHtml += extend2Data[q].mainPerson + " . ";
                  }
                  if (extend2Data[q].bookName != undefined) {
                    extendHtml += extend2Data[q].bookName + " . ";
                  }
                  if (extend2Data[q].publishAddress != undefined) {
                    extendHtml += extend2Data[q].publishAddress + " : ";
                  }
                  if (extend2Data[q].publishauthor != undefined) {
                    extendHtml += extend2Data[q].publishauthor + " . ";
                  }
                  if (extend2Data[q].publishYear != undefined) {
                    extendHtml += extend2Data[q].publishYear + " . ";
                  }
                  extendHtml += "</li>";
                }
              } else if (extendData[m].type == "3") {
                var extend3Data = extendData[m].list;
                for (var r = 0; r < extend3Data.length; r++) {
                  extendHtml += "<li>";
                  if (extend3Data[r].linkAddress != undefined) {
                    extendHtml +=
                      "<a href='" +
                      extend3Data[r].linkAddress +
                      "' target='_blank'>";
                  }
                  if (extend3Data[r].mainPerson != undefined) {
                    extendHtml += extend3Data[r].mainPerson + " . ";
                  }
                  if (extend3Data[r].bookName != undefined) {
                    extendHtml += extend3Data[r].bookName + " . ";
                  }
                  if (extend3Data[r].linkAddress != undefined) {
                    extendHtml += "</a>";
                  }
                  if (extend3Data[r].bookNameL != undefined) {
                    extendHtml += extend3Data[r].bookNameL + " , ";
                  }
                  if (extend3Data[r].publishYear != undefined) {
                    extendHtml += extend3Data[r].publishYear + " . ";
                  }
                  if (extend3Data[r].Volume != undefined) {
                    extendHtml += extend3Data[r].Volume + " . ";
                  }
                  if (extend3Data[r].pageNumber != undefined) {
                    extendHtml += extend3Data[r].pageNumber + " . ";
                  }
                  extendHtml += "</li>";
                }
              } else if (extendData[m].type == "4") {
                var extend4Data = extendData[m].list;
                for (var n = 0; n < extend4Data.length; n++) {
                  extendHtml += "<li>";
                  if (extend4Data[n].linkAddress != undefined) {
                    extendHtml +=
                      "<a href='" +
                      extend4Data[n].linkAddress +
                      "' target='_blank'>";
                  }
                  if (extend4Data[n].bookName != undefined) {
                    extendHtml += extend4Data[n].bookName + " . ";
                  }
                  if (extend4Data[n].websiteName != undefined) {
                    extendHtml += extend4Data[n].websiteName + " . ";
                  }
                  if (extend4Data[n].linkAddress != undefined) {
                    extendHtml += "</a>";
                  }
                  extendHtml += "</li>";
                }
              } else if (extendData[m].type == "5") {
                var extend5Data = extendData[m].list;
                for (var t = 0; t < extend5Data.length; t++) {
                  extendHtml += "<li>";
                  if (extend5Data[t].linkAddress != undefined) {
                    extendHtml +=
                      "<a href='" +
                      extend5Data[t].linkAddress +
                      "' target='_blank'>";
                  }
                  if (extend5Data[t].name != undefined) {
                    extendHtml += extend5Data[t].name;
                  }
                  if (extend5Data[t].linkAddress != undefined) {
                    extendHtml += "</a>";
                  }
                  extendHtml += "</li>";
                }
              }
            }
            $(".extendContent .extendList").html(extendHtml);
          } else {
            $(".extendContent").hide();
          }

          $(".previewContent").html(data.content);
          $(".previewContent p").each(function() {
            $(this).html($(this).html().trimStart())
          });

          $("note").each(function () {
            var sup = $(this).attr("title");
            if (sup && sup.length > 0) {
              $(this).addClass("websup");
              $(this).webuiPopover({
                placement: "bottom",
                trigger: "hover",
                title: "注释内容",
                content: sup,
                width: 200,
              });
            }
          });

          // 获取修改时间
          var timestamp = data.modifyTime;
          var date = new Date(timestamp);
          that.modifyTime =
            date.getFullYear() +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + date.getDate()).slice(-2) +
            " " +
            ("0" + date.getHours()).slice(-2) +
            ":" +
            ("0" + date.getMinutes()).slice(-2) +
            ":" +
            ("0" + date.getSeconds()).slice(-2);

          //生成目录

          var getMenuDiv = $(
            ".previewContent h1,.previewContent h2,.previewContent h3,.previewContent h4,.previewContent h5"
          );
          if (getMenuDiv.length != 0) {
            var hEles = ["h1", "h2", "h3", "h4", "h5"];
            $.each(getMenuDiv, function (index, element) {
              var nodetext = element.innerHTML.replace(/<\/?[^>]+>/g, "");
              nodetext = nodetext.replace(/&nbsp;/gi, "");
              var name = element.nodeName.toLowerCase();
              if (hEles.includes(name)) {
                index++;
                var id = `catalogue_${index}`;
                element.setAttribute("id", id);
                var level = name.replace("h", "");
                that.catalogue.push({
                  id: id,
                  key: name,
                  title: nodetext,
                  level: Number(level),
                  read: false,
                });
              }
            });
          } else {
            $("#publishContent .menuBox").hide();
          }

          //图集处理开始
          let contentUnionImg = $(".previewContent .pic-union");
          for (let i = 0; i < contentUnionImg.length; i++) {
            // 创建外层盒子
            let picUnionTopBox = $("<span class='pic-union-top' style='text-indent = 0'></span>");
            let currentUnion = $(contentUnionImg[i]);
            if (currentUnion.css("float") == "left") {
              currentUnion
                .wrap($('<a class="pic-union-box fl"></a>'))
                .wrap(picUnionTopBox);
            } else if (currentUnion.css("float") == "right") {
              currentUnion
                .wrap($('<a class="pic-union-box fr"></a>'))
                .wrap(picUnionTopBox);
            } else {
              currentUnion
                .wrap($('<a class="pic-union-box"></a>'))
                .wrap(picUnionTopBox);
            }
            
            setTimeout(() => {
              $(contentUnionImg[i])
                .parent()
                .parent(".pic-union-box")
                .css("width", $(contentUnionImg[i]).css("width"));
            }, 200);
            var galleryDataAll = {
              metaids: $(contentUnionImg[i]).attr("metaids").split("##"),
              metaposters: $(contentUnionImg[i])
                .attr("metaposters")
                .split("##"),
              metatitles: $(contentUnionImg[i]).attr("metatitles").split("##"),
            };
            var galleryData = [];
            var postAlt = ""
            galleryDataAll.metaids.forEach((item, index) => {
              if(currentUnion.attr('logopath').indexOf(galleryDataAll.metaposters[index]) == -1){
                 galleryData.push({
                  id: item,
                  poster: galleryDataAll.metaposters[index],
                  title: galleryDataAll.metatitles[index],
                });
              }else{
                postAlt = galleryDataAll.metatitles[index]
              }
            });
            let titleUnion = $(contentUnionImg[i]).attr("title");
            $("<div class='pic-union-font'>" + titleUnion + "</div>").appendTo(
              $(contentUnionImg[i]).parent().parent()
            );
            var galleryHtml =
              '<div class="gallery-thumbs"><p class="galleryLogo">图集</p><img src="'+currentUnion.attr('logopath')+'" alt="'+postAlt+'" style="width:100%"><div class="gallery-thumbs-content" style="display:none">';
            galleryData.forEach((item) => {
              galleryHtml +=
                '<img src="' +
                item.poster +
                '" alt="' +
                item.title +
                '">';
            });
            galleryHtml += '</div></div>';
            currentUnion.parent().html(galleryHtml);
          }
            $(".previewContent .pic-union-box").viewer({
                url: 'httpPath',
                navbar: true,
                title: true,
                toolbar:true
            })
          // var galleryThumbs = new Swiper(".gallery-thumbs .swiperBox", {
          //   spaceBetween: 10,
          //   slidesPerView: 1,
          //   // direction: "vertical",
          //   loop : true,
          //   watchSlidesVisibility: true,
          //   watchSlidesProgress: true,
          //   prevButton:'.swiper-button-prev',
          //   nextButton:'.swiper-button-next',
          //   // pagination: {
          //   //   el: ".swiper-pagination",
          //   // },
          // });
          // var galleryTop = new Swiper(".gallery-top", {
          //   spaceBetween: 10,
          //   // mousewheel: true,
          //   effect: "fade",
          //   // navigation: {
          //   //   nextEl: ".next",
          //   //   prevEl: ".prev",
          //   // },
          //   thumbs: {
          //     swiper: galleryThumbs,
          //   },
          //   on: {
          //     slideChange: function () {
          //       $(".current").text(galleryTop.realIndex + 1);
          //       var name = $(".image-set div.name")
          //         .eq(galleryTop.realIndex)
          //         .html();
          //       $(".imgtitle").html(name);
          //       var src = $("#topBox .swiper-slide")
          //         .eq(galleryTop.realIndex)
          //         .find("img")
          //         .attr("src");
          //       that.openSea(src);
          //     },
          //   },
          // });

          // $('.swiper-button-prev').click(() => {
          //  galleryThumbs.slidePrev();
          // })
          // $('.swiper-button-next').click(() => {
          //  galleryThumbs.slideNext();
          // })
          //图集处理结束

          // 单张图片处理开始
          var contentSingleImg = $(".previewContent .pic-single");
          contentSingleImg.each(function (index, item) {
            // 创建外层盒子
            var setTimeIndex = index;
            var picSingleTopBox = $("<span class='pic-single-top'></span>");
            var currentSingle = $(item);
            if (currentSingle.css("float") == "left") {
              currentSingle
                .wrap($('<a class="pic-single-box fl"></a>'))
                .wrap(picSingleTopBox);
            } else if (currentSingle.css("float") == "right") {
              currentSingle
                .wrap($('<a class="pic-single-box fr"></a>'))
                .wrap(picSingleTopBox);
            } else {
              currentSingle
                .wrap($('<a class="pic-single-box"></a>'))
                .wrap(picSingleTopBox);
            }

            $(".previewContent .pic-single-box")
              .parent()
              .each(function (index, item) {
                if ($(item).attr("align")) {
                  switch ($(item).attr("align")) {
                    case "center":
                      $(item).css({
                        "text-align": "center",
                      });
                      break;
                    case "left":
                      $(item).css({
                        "text-align": "left",
                      });
                      break;
                    case "right":
                      $(item).css({
                        "text-align": "right",
                      });
                      break;

                    default:
                      break;
                  }
                }
              });
            if (
              $(".previewContent .pic-single-box")
                .parent()
                .contents()
                .filter(function () {
                  return (
                    this.nodeType === 1 && this.nodeName.toLowerCase() !== "a"
                  ); // 1代表元素节点，且不是<a>标签
                }).length > 0
            ) {
              $(".previewContent .pic-single-box").css({
                float: "right",
                margin: "10px 0 10px 20px",
              });
            } else {
              currentSingle.parent().parent().parent().css({
                "text-indent": 0,
                margin: "20px 0",
                "text-align": "center",
              });
            }

            if (
              that.hasMixedContentJQuery(
                $(".previewContent .pic-single-box").parent()
              )
            ) {
              $(".previewContent .pic-single-box").css({
                float: "right",
                margin: "10px 0 10px 20px",
              });
            }

            $("video").parent().css({ "text-indent": 0 });

            // 若有图注则显示图注
            var imageNote = currentSingle.attr("imagenote");
            if (imageNote && imageNote != "") {
              $(
                "<div class='pic-imagenote-font'>" + imageNote + "</div>"
              ).appendTo(currentSingle.parent().parent());
            }
            // 若有图题则显示图题
            var titleSingle = currentSingle.attr("title");
            if (titleSingle && titleSingle != "") {
              currentSingle.on("load", function () {
                var imgWidth = currentSingle.width();
                $(
                  "<div class='pic-single-font' style='width:" +
                    imgWidth +
                    "px'>" +
                    titleSingle +
                    "</div>"
                ).appendTo(currentSingle.parent().parent());
              });
            }
            setTimeout(
              () => {
                $(contentSingleImg[setTimeIndex])
                  .parent()
                  .parent(".pic-single-box")
                  .css("width", $(contentSingleImg[setTimeIndex]).css("width"));
              },
              500,
              j
            );

            // 若有链接则显示跳转
            let imageLink = currentSingle.attr("imagelink");
            if (imageLink && imageLink != "") {
              currentSingle
                .parent()
                .parent(".pic-single-box")
                .attr("href", imageLink);
              currentSingle
                .parent()
                .parent(".pic-single-box")
                .addClass("addeffect");
            }
          });
          // $(".previewContent img").on({}).viewer({
              contentSingleImg.on({}).viewer({
                url: 'httpPath',
                navbar: false,
                title: true
            }) 
          //单张图片处理结束

          // h1处理开始
          var contentH1 = $(".previewContent h1");
          contentH1.each(function (index, item) {
            var picSingleTopBox = $("<div class='h1Title'></div>");
            var currentSingle = $(item);
            currentSingle.wrap(picSingleTopBox);
            var currentBox = $(".h1Title")[index];
            $(currentBox).append("<span class='h1Title-line'></span>");
          });
          // h1处理结束

          var userAgent = window.navigator.userAgent;

          $("img.reference").each(function (index, item) {
            let sup = $(item).attr("data-text");
            let supItem = $(
              '<sup style="color:#596fab" attr="' +
                sup +
                '">[' +
                (index + 1) +
                "]</sup>"
            )[0];
            $(supItem).addClass("websup");
            $(supItem).webuiPopover({
              placement: "bottom",
              trigger: "hover",
              title: "注释内容",
              content: sup,
            });
            if (
              userAgent.indexOf("MSIE") == -1 &&
              userAgent.indexOf("Trident") == -1 &&
              userAgent.indexOf("rv:11.0") == -1
            ) {
              item.replaceWith(supItem);
            }
          });

          // 添加图注
          // $(".previewContent img").each(function () {
          //   if ($(this).attr("data-type")) {
          //     $("img.reference").each(function (index, item) {
          //       let sup = $(item).attr("data-text");
          //       let supItem = $(
          //         '<sup style="color:#596fab" attr="' +
          //           sup +
          //           '">[' +
          //           (index + 1) +
          //           "]</sup>"
          //       )[0];
          //       $(supItem).addClass("websup");
          //       $(supItem).webuiPopover({
          //         placement: "bottom",
          //         trigger: "hover",
          //         title: "注释内容",
          //         content: sup,
          //       });
          //       item.replaceWith(supItem);
          //     });
          //   } else {
          //     $(".previewContent img").parent().addClass("imgBox");
          //     setTimeout(function () {
          //       $(this)
          //         .parent()
          //         .append(
          //           "<span style='width:" +
          //             $(this).width() +
          //             "px'>" +
          //             $(this).attr("title") +
          //             "</span>"
          //         );
          //       // $.each($(".previewContent img"), function () {

          //       // });
          //     }, 100);
          //   }
          // });
          //
          // 处理图片点击;
          // 获取当前点击图片的resourceid;
          // $(".previewContent img").click(function () {
          //   that.swiperImages = data.resourceInfos;

          //   $(".picLarge img").attr(
          //     "src",
          //     that.swiperImages[$($(this)[0]).attr("resourceid")].httpPath
          //   );
          //   $(".picLarge").show();
          //   // var allValues = $.map(that.swiperImages, function (obj) {
          //   //   return [obj];
          //   // }).flat(); // 使用flat方法将二维数组展平为一维数组
          //   // var currentIndex = 0;
          //   // allValues.forEach((item, index) => {
          //   //   if ($($(this)[0]).attr("resourceid") == item.id) {
          //   //     currentIndex = index;
          //   //   }
          //   // });
          //   // that.swiperOptions.initialSlide = currentIndex;
          //   // // that.$refs.mySwiper.swiper.update();

          //   //
          //   // console.log(that.$refs.mySwiper.swiper.activeIndex);
          // });

          // 处理热链
          $("hotlink").each(function (index, item) {
            var itemInfo = {};
            itemInfo.title = item.innerHTML;
            if ($(item).attr("name")) {
                item.replaceWith(
                  $(
                    '<a class="hotlink" target="_blank" href= "/detail?name=' +
                      $(item).attr("name") +
                      '&sourceId=' +
                      data.id +
                      '">' +
                      itemInfo.title +
                      '</a >'
                  )[0]
                );
              // if ($(item).attr("innerCode")) {
              //   item.replaceWith(
              //     $(
              //       '<a class="hotlink" target="_blank" href= /detail?name=' +
              //         $(item).attr("name") +
              //         "&code=" +
              //         $(item).attr("innerCode") +
              //         ">" +
              //         itemInfo.title +
              //         "</a >"
              //     )[0]
              //   );
              // } else if ($(item).attr("code")) {
              //   item.replaceWith(
              //     $(
              //       '<a class="hotlink" target="_blank" href= /detail?name=' +
              //         $(item).attr("name") +
              //         "&code=" +
              //         $(item).attr("code") +
              //         ">" +
              //         itemInfo.title +
              //         "</a >"
              //     )[0]
              //   );
              // }
            } else if ($(item).attr("id")) {
              itemInfo.id = $(item).attr("id");
              item.replaceWith(
                $(
                  '<a class="hotlink" target="_blank" href= "/detail?id=' +
                    itemInfo.id +
                    '">' +
                    itemInfo.title +
                    '</a >'
                )[0]
              );
            } else if ($(item).attr("url")) {
              var currentUrl = $(item).attr("url");
              itemInfo.id = that.getQueryParamValue(currentUrl, "wordId");
              item.replaceWith(
                $(
                  '<a class="hotlink" target="_blank" href= "/detail?id=' +
                    itemInfo.id +
                    '">' +
                    itemInfo.title +
                    "</a >"
                )[0]
              );
            }
          });

          if(that.adFlag) {
            $(".mainContent").css({'border-bottom': '2px solid #cd2022','padding-bottom':'30px'});
          }
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
          window.location.href = "/blank";
        }
      },
      error: function () {
        // window.location.href = "/blank";
      },
    });
  },
  methods: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    menuClick(current) {
      current.read = true;
      var anchorElement = $("#" + current.id);
      if (anchorElement.length > 0) {
        $("html, body").animate(
          {
            scrollTop: anchorElement.offset().top - 120,
          },
          500
        );
      }
      $(".catalogue-box #menu" + current.id).addClass("catalogueActive");
      $(".catalogue-box #menu" + current.id)
        .siblings()
        .removeClass("catalogueActive");
    },
    getQueryParamValue(currentUrl, paramName) {
      var params = new URLSearchParams(currentUrl.split("?")[1]);
      return params.get(paramName);
    },
    updateScrollDistance() {
      this.scrollDistance =
        window.pageYOffset || document.documentElement.scrollTop;
      var scrollTop = this.scrollDistance;
      for (let i = 0; i < this.catalogue.length; i++) {
        //获取小标题距离屏幕顶端的距离
        var offsetTop = document.querySelector(
          "#" + this.catalogue[i].id
        ).offsetTop;
        //根据条件做出判断，我这里是当小标题和屏幕顶端的距离小于300且没有被标明在读时，就将其背景颜色改变。
        if (offsetTop - scrollTop < 300 && offsetTop - scrollTop > 0) {
          $(".catalogue-box #menu" + this.catalogue[i].id).addClass(
            "catalogueActive"
          );
          $(".catalogue-box #menu" + this.catalogue[i].id)
            .siblings()
            .removeClass("catalogueActive");
        }
      }
    },
    printPage() {
      window.print();
    },
    closeSide() {
      if ($(".menuBox").css("left").indexOf("-") !== -1) {
        $(".menuBox").animate(
          {
            left: "0%", // 向右移动100px
          },
          "slow"
        );
        $("#publishContent .menuBox .menuButton i").removeClass("el-icon-notebook-2");
        $("#publishContent .menuBox .menuButton i").addClass("el-icon-close");
      } else {
        if (window.innerWidth <= 768) {
          $(".menuBox").animate(
            {
              left: "-49%", // 向右移动100px
            },
            "slow"
          );
        } else if (window.innerWidth <= 1200) {
          $(".menuBox").animate(
            {
              left: "-34%", // 向右移动100px
            },
            "slow"
          );
        } else {
          $(".menuBox").animate(
            {
              left: "-16.5%", // 向右移动100px
            },
            "slow"
          );
        }

        $("#publishContent .menuBox .menuButton i").addClass("el-icon-notebook-2");
        $("#publishContent .menuBox .menuButton i").removeClass("el-icon-close");
      }
    },
    // 字体放大s
    fontLarge() {
      $(".fontsize").each(function () {
        var cssfontSize, csslineHeight;
        if ($(this).hasClass("adv-content")) {
          cssfontSize = $(this).find("p").css("font-size");
          csslineHeight = $(this).find("p").css("line-height");
        } else {
          cssfontSize = $(this).css("font-size");
          csslineHeight = $(this).css("line-height");
        }

        var unit = cssfontSize.slice(-2);
        var fontSize = parseFloat(cssfontSize);
        var lineHeight = parseFloat(csslineHeight);
        if (fontSize > 22) return false;
        fontSize = fontSize + 2;
        lineHeight = lineHeight + 2;
        if ($(this).hasClass("adv-content")) {
          $(this)
            .find("*")
            .css("font-size", fontSize + unit);
          $(this)
            .find("*")
            .css("line-height", lineHeight + unit);
        } else {
          $(this).css("font-size", fontSize + unit);
          $(this).css("line-height", lineHeight + unit);
        }
      });
    },
    // 字体缩小
    fontNarrow() {
      $(".fontsize").each(function () {
        var cssfontSize, csslineHeight;
        if ($(this).hasClass("adv-content")) {
          cssfontSize = $(this).find("p").css("font-size");
          csslineHeight = $(this).find("p").css("line-height");
          if (!cssfontSize) {
            cssfontSize = 16;
            csslineHeight = 28;
          }
        } else {
          cssfontSize = $(this).css("font-size");
          csslineHeight = $(this).css("line-height");
        }

        var unit = cssfontSize.slice(-2);
        var fontSize = parseFloat(cssfontSize);
        var lineHeight = parseFloat(csslineHeight);
        if (fontSize < 14) return false;
        fontSize = fontSize - 2;
        lineHeight = lineHeight - 2;
        if ($(this).hasClass("adv-content")) {
          $(this)
            .find("*")
            .css("font-size", fontSize + unit);
          $(this)
            .find("*")
            .css("line-height", lineHeight + unit);
        } else {
          $(this).css("font-size", fontSize + unit);
          $(this).css("line-height", lineHeight + unit);
        }
      });
    },
    // 关闭图片放大
    picLargeClose() {
      $(".picLarge").hide();
    },
    hasMixedContentJQuery($span) {
      // 检查是否有直接文本内容（非空）
      const hasText =
        $span.contents().filter(function () {
          return this.nodeType === 3 && $.trim(this.textContent) !== "";
        }).length > 0;

      // 检查是否有a标签
      const hasAnchor = $span.find("a").length > 0;

      return hasText && hasAnchor;
    },
    openSea() {
      // $("#openseadragon").empty();
      // OpenSeadragon({
      //   id: "openseadragon",
      //   prefixUrl: "/web/img/detail/",
      //   defaultZoomLevel: 0,
      //   minZoomImageRatio: 0.1,
      //   maxZoomPixelRatio: 5,
      //   tileSources: {
      //     type: "image",
      //     url: src,
      //   },
      // });

      if ($(window).width() < 768) {
        $("div[title='缩小']").parent("div").hide();
      } else {
        $("div[title='缩小']").parent("div").show();
      }
      var flag = true;
      function autodivheight() {
        if (flag) {
          flag = false;
          $(".resourceimgcover")
            .removeClass("resource70")
            .addClass("resource100");
        } else {
          flag = true;
          $(".resourceimgcover")
            .removeClass("resource100")
            .addClass("resource70");
        }
        if ($(window).width() < 768) {
          $("div[title='缩小']").parent("div").hide();
        } else {
          $("div[title='缩小']").parent("div").show();
        }
      }
      window.onresize = autodivheight;
    },
    prev(){
      console.log(this.swiper);
      this.swiper.slidePrev();
    },
    next(){
      this.swiper.slideNext();
    },
    closeAdver(){
      $("#adBox").hide()
      $("#adSide").hide()
    }
  },
};
</script>

<style>
#publishContent {
  position: relative;
  font-family: "DBKai";
}

#publishContent .menuBox {
  position: fixed;
  width: 15%;
  padding: 20px 10px 20px 10px;
  height: calc(100% - 71px);
  top: 70px;
  left: -16.5%;
  box-shadow: 1px 3px 8px 0px rgba(102, 102, 102, 0.5);
  border-left: 5px solid #cd2022;
  color: #888;
  z-index: 999;
  background-color: #fff;
}

#publishContent .menuBox .nav-title {
  font-size: 18px;
  margin-bottom: 30px;
}
#publishContent .menuBox .catalogue-box {
  padding-left: 10px;
}

#publishContent .menuBox .catalogue-box li {
  padding: 5px 0;
  margin: 15px 0;
  cursor: pointer;
}
#publishContent .menuBox .catalogue-box li::marker {
  color: #cd2022;
}

#publishContent .menuBox .catalogue-box li:hover a {
  color: #cd2022;
  font-weight: bolder;
  /* background-color: rgba(80, 181, 141, 0.1); */
}

#publishContent .menuBox .catalogue-box li.catalogueActive a {
  color: #cd2022;
  font-weight: bolder;
  /* background-color: rgba(80, 181, 141, 0.1); */
}

#publishContent .menuBox .catalogue-box li a {
  color: #888;
}

#publishContent .menuBox .catalogue-box .catalogue1 {
  font-size: 18px;
}

#publishContent .menuBox .catalogue-box .catalogue2 {
  font-size: 17px;
  list-style-type: disc;
  list-style-position: inside;
  padding-left: 10px;
}

#publishContent .menuBox .catalogue-box .catalogue2 a {
  margin-left: -15px;
}

#publishContent .menuBox .catalogue-box .catalogue3 {
  font-size: 16px;
  list-style-type: circle;
  list-style-position: inside;
  padding-left: 20px;
}
#publishContent .menuBox .catalogue-box .catalogue3 a {
  margin-left: -12px;
}

#publishContent .menuBox .catalogue-box .catalogue4 {
  font-size: 15px;
  list-style-type: square;
  list-style-position: inside;
  padding-left: 30px;
}

#publishContent .menuBox .catalogue-box .catalogue4 a {
  margin-left: -9px;
}

#publishContent .menuBox .catalogue-box .catalogue5 {
  font-size: 14px;
  list-style-type: disc;
  list-style-position: inside;
  padding-left: 40px;
}

#publishContent .menuBox .catalogue-box .catalogue5 a {
  margin-left: -6px;
}

#publishContent .menuBox .menuButton {
  position: absolute;
  top: 0px;
  right: -40px;
  width: 40px;
  height: 40px;
  padding: 0;
  background: #cd2022;
  color: #fff;
  cursor: pointer;
  font-size: 30px;
  border-radius: 0;
}

#publishContent .picLarge {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  text-align: center;
}

#publishContent .picLarge .el-button {
  position: fixed;
  top: 0;
  right: 0;
  border: 0;
  background: none;
  color: #fff;
  font-size: 50px;
  z-index: 1001;
}

#publishContent .picLarge img {
  display: block;
  height: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#publishContent .subBranch {
  padding-top: 20px;
  font-size: 14px;
  color: #335a98;
}

#publishContent .contentBox {
  padding: 70px 20% 0;
}

#publishContent .contentBox .descText {
  margin: 30px 0;
}

#publishContent .contentBox .summaryFields {
  border-top: 1px solid #e6bcbc;
}

#publishContent .contentBox .articleTitleBox {
  padding-top: 20px;
  margin: 0;
  padding-bottom: 10px;
}

#publishContent .contentBox .articleTitleBox .authorBox {
  background: url(../../../../img/icon3.png) no-repeat left center;
  padding-left: 40px;
  margin: 6px 0px;
  cursor: pointer;
}

#publishContent .contentBox .articleTitleBox .authorBox .i-author {
  display: block;
  color: #a9a9a9;
  font-size: 12px;
}

#publishContent .contentBox .articleTitleBox .authorBox .n-author {
  display: block;
  color: #000000;
  font-size: 14px;
}

#publishContent .contentBox .articleTitleBox .authorBox .n-author .author-span {
  margin-right: 5px;
}

#publishContent .contentBox .articleTitleBox .itemTitle {
  font-size: 40px;
  padding: 0;
  color: #000;
  font-weight: bolder;
  /* float: left; */
}

#publishContent .contentBox .previewContent p {
  line-height: 1.8em !important;
  font-size: 16px;
  text-align: justify;
  text-indent: 2em;
}

#publishContent .contentBox .previewContent h2 {
  margin: 15px 0;
  font-weight: normal;
}

#publishContent .contentBox .previewContent h2::before {
  content: "•"; /* 使用Unicode字符表示点 */
  margin-right: 15px; /* 可选，为点和文本之间添加一些空间 */
  color: #cd2022;
}

#publishContent .contentBox .previewContent h3 {
  margin: 20px 0;
}

#publishContent .contentBox .previewContent h4 {
  margin: 10px 0;
}

#publishContent .contentBox .previewContent {
  padding: 0;
}

#publishContent .contentBox .previewContent video {
  max-width: 80%;
}

#publishContent .contentBox .moduleTitle {
  font-size: 18px;
  font-weight: normal;
  border-bottom: 1px solid rgb(205, 32, 34);
  color: #000;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 30px;
}

#publishContent .contentBox .mainContent {
  margin-top: 20px;
  margin-bottom: 50px;
}

#publishContent .contentBox .mainContent .imgBox span,
#publishContent .contentBox .mainContent .imgBox img {
  display: block;
  margin: 0 auto;
}

#publishContent .contentBox .mainContent .imgBox img {
  max-width: 100%;
}

#publishContent .contentBox .mainContent .imgBox span {
  padding: 5px 0;
  border-bottom: 2px solid #cd2022;
  box-shadow: 0px 0px 2px 0 #cdcdcd;
}

#publishContent .contentBox .basicInfo .basicContent {
  overflow: auto;
}

#publishContent .contentBox .basicInfo .basicContent::after {
  content: "";
  display: inline-block;
  clear: both;
}

#publishContent .contentBox .basicInfo .basicContent div {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

#publishContent .contentBox .basicInfo .basicContent p span {
  font-weight: bolder;
}

#publishContent .descImgContent .descImg img {
  width: 100%;
}

.infoText {
  overflow: auto;
}

.infoText::after {
  content: "";
  display: inline-block;
  clear: both;
}

.infoText .summaryName,
.infoText .summaryValue {
  float: none;
  width: 100%;
  margin: 0;
}

.infoText .summaryName {
  color: #888888;
  line-height: 22px;
  font-size: 12px;
  font-weight: normal;
}

.infoText .el-col {
  padding: 5px 0px;
  margin: 0px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.16);
}

.infoText .summaryValue {
  color: #333333;
  line-height: 22px;
  font-size: 12px;
  font-family: "Microsoft Yahei", "宋体", DBK;
}

.opusContent .opusList,
.refContent .refList,
.extendContent .extendList,
.otherExtendContent .otherExtendList {
  padding-left: 20px;
  margin-bottom: 50px;
}

.opusContent .opusList li,
.refContent .refList li,
.extendContent .extendList li,
.otherExtendContent .otherExtendList li {
  list-style-type: disc;
  margin: 10px 0;
}

.refContent .refList li a,
.extendContent .extendList li a,
.otherExtendContent .otherExtendList li a {
  color: #cd2022;
}

.previewPageTitle {
  margin-top: 20px;
  height: 45px;
}

.previewPageTitle img {
  float: left;
  display: block;
  margin-right: 10px;
}

.previewPageTitle span {
  display: block;
  line-height: 45px;
}

#publishContent .contentBox .articleTitleBox .englishTitle {
  color: rgb(205, 32, 34);
  font-size: 12px;
  line-height: 74px;
  margin: 0px 10px -30px;
  font-weight: normal;
  letter-spacing: 0.01em;
}

#publishContent .contentBox .timeHitsBox {
  background-color: #eeeeee;
  border-bottom: 2px solid #cd2022;
  padding: 13px 15px;
  color: #909090;
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 10px;
}

#publishContent .contentBox .timeHitsBox .fontButton {
  text-align: right;
}

#publishContent .contentBox .timeHitsBox .fontButton .enlarge {
  background: url(../../../../img/icon9.png) no-repeat center center;
  display: inline-block;
  width: 18px;
  height: 23px;
  margin: 0px 10px;
}

#publishContent .contentBox .timeHitsBox .fontButton .narrow {
  background: url(../../../../img/icon10.png) no-repeat center center;
  display: inline-block;
  width: 18px;
  height: 23px;
  margin: 0px 10px;
}

#publishContent .publishPreviewNav {
  box-shadow: 0px 0px 24px 0px #0000001c;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 999;
  padding: 15px 30px;
  border-left: 5px solid #cd2022;
}

#publishContent .publishPreviewNav .publishNavTitle {
  font-size: 24px;
  font-weight: bolder;
  position: absolute;
  top: 50%;
  transform: translateY(-60%);
  margin-left: 10px;
}

#publishContent .publishFooter {
  width: 100%;
  background-color: #2f2f2f;
  padding: 50px 0;
}

#publishContent .publishFooter .footerContent {
  text-align: center;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.38);
  font-size: 14px;
}

#publishContent .publishFooter .footerContent p + p {
  margin-top: 10px;
}

#publishContent .contentBox .pic-single-top img {
  max-width: 500px;
  max-height: 400px;
}

#publishContent .contentBox .pic-single-box {
  /* text-align: center; */
  text-indent: 0;
  display: block;
  margin: 0 auto;
}

#publishContent .contentBox .pic-single-font {
  margin: 0 auto;
  margin-top: -10px;
  background-color: #fff;
  border-bottom: 1px solid #cd2022;
  box-shadow: 0px 0px 3px 0px rgba(102, 102, 102, 0.5);
}

#publishContent .contentBox .h1Title {
  position: relative;
  overflow: auto;
}

#publishContent .contentBox .h1Title ::after {
  content: "";
  display: inline-block;
  clear: both;
}

#publishContent .contentBox .h1Title h1 {
  background-color: #fff;
  position: relative;
  float: left;
  z-index: 10;
  width: auto;
  margin: 10px 0;
  padding-right: 10px;
}

#publishContent .contentBox .h1Title .h1Title-line {
  position: absolute;
  width: 100%;
  height: 1px;
  background: #d5d5d5;
  top: 50%;
  right: 0;
}

#publishContent .chronologyContent li{
  margin: 30px 0;
}

#publishContent .chronologyContent .chronologyItemTitle{
  font-size: 26px;
  font-weight: bolder;
  color:#888888;
  margin-bottom: 15px;
}

#publishContent .chronologyContent .chronologyItemContent p{
  line-height: 1.7em;
  margin: 15px 0;
}

#publishContent .gallery-thumbs{
  position: relative;
  width: 400px;
  margin: 0 auto;
  text-indent: 0;
}

#publishContent .gallery-thumbs .galleryLogo{
  position: absolute;
  top: 1%;
  left: 1%;
  width: 75px;
  height: 25px;
  border-radius: 5px;
  z-index: 10;
  font-size: 14px !important;
  text-align: center !important;
  background: rgba(205, 32, 34, 0.85);
  color: #fff;
  text-indent: 0!important;
  opacity: 0.85;
}

#publishContent .pic-union-font{
  width: 400px;
  margin: 0 auto;
  text-align: center;
  text-indent: 0;
  padding: 10px 0;
  margin-top: -10px;
  background-color: #fff;
  border-bottom: 1px solid #cd2022;
  box-shadow: 0px 0px 3px 0px rgba(102, 102, 102, 0.5);
}

#publishContent #adBox{
  width: 500px;
  margin: 0 auto 50px;
  position: relative;
  color: #fff;
  font-size: 14px;
}
#publishContent #adBox img{
  width: 100%;
}
#publishContent #adBox span{
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 3px 5px;
  cursor: pointer;
}

#publishContent #adSide{
  position: fixed;
  right: 0;
  top: 45%;
  width: 15vw;
  color: #fff;
  font-size: 14px;
}

#publishContent #adSide img{
  width: 100%;
}

#publishContent #adSide span{
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 3px 5px;
  cursor: pointer;
}

@media screen and (max-width: 1200px) {
  #publishContent .menuBox {
    width: 30%;
    padding: 20px 10px 20px 10px;
    /* height: 100vh; */
    left: -34%;
  }

  #publishContent .contentBox {
    padding: 70px 10% 0 !important;
  }
}

@media screen and (max-width: 768px) {
  #publishContent .contentBox .articleTitle p {
    font-size: 26px;
    padding: 0px 0;
  }

  #publishContent .contentBox .pic-single-top img {
    width: 100%;
    max-height: none;
  }

  #publishContent .contentBox .previewContent {
    padding: 0;
  }

  #publishContent .contentBox .previewContent video {
    width: 100%;
  }

  #publishContent .picLarge img {
    width: 100%;
    height: auto;
  }

  #publishContent .menuBox {
    width: 45%;
    left: -49%;
  }

  #publishContent .menuBox .catalogue-box li {
    margin: 5px 0;
  }

  #publishContent .menuBox .catalogue-box li a {
    font-size: 14px;
  }

  #publishContent .menuBox .nav-title {
    margin-bottom: 0;
  }

  #publishContent .gallery-thumbs{
    width: 100%;
  }

  #publishContent .pic-union-font{
    width: 100%;
  }

  #publishContent #adBox{
    width: 100%;
  }
}

#publishContent .pic-imagenote-font {
  margin-bottom: 15px;
}
/* #publishContent .swiper-container {
  width: 99%;
  max-width: 100%;
  height: 95%;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

#publishContent .swiper-wrapper {
  height: 95%;
}

#publishContent .swiper-slide {
  text-align: center;
}

#publishContent .slide-image {
  width: auto;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}

#publishContent .swiper-button-prev,
#publishContent .swiper-button-next,
.swiper-pagination-bullet-active,
#publishContent .swiper-button-prev,
#publishContent .swiper-container-rtl .swiper-button-next {
  --swiper-theme-color: #fff;
} */

/* #publishContent
  .swiper-container-horizontal
  > #publishContent
  .swiper-pagination-bullets
  #publishContent
  .swiper-pagination-bullet {
  --swiper-theme-color: #cd2022;
} */


#publishContent .swiper-slide{
  width: 100%;
}

#publishContent .swiper-slide div {
  position: relative;
  width: 100%;
}

#publishContent .swiper-slide div img{
  width: 100%;
}

#publishContent .swiper-slide div span {
  position: absolute;
  width: 100%;
  line-height: 2em;
  background-color: rgba(255, 255, 255, 0.5);
  bottom: 7px;
  left: 0;
  font-size: 14px;
}

#publishContent .swiper-pagination-bullet-active {
  --swiper-theme-color: #cd2022;
}

#publishContent .swiper-pagination-fraction,
#publishContent .swiper-pagination-custom,
#publishContent .swiper-container-horizontal > #publishContent .swiper-pagination-bullets {
  bottom: 0;
}

#publishContent
  .swiper-container-horizontal
  > #publishContent
  .swiper-pagination-bullets
  #publishContent
  .swiper-pagination-bullet {
  border: 1px solid #fff;
  opacity: 1;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -9px !important;
}

#publishContent .swiper-button-prev, #publishContent .swiper-container-rtl #publishContent .swiper-button-next{
    left: 5% !important;
}

#publishContent .swiper-button-next, #publishContent .swiper-container-rtl #publishContent .swiper-button-prev{
    right: 5% !important;
}

.viewer-backdrop{
  background-color: rgba(0, 0, 0, 0.8) !important;

}

.viewer-title{
  display: block !important;
  font-size: 18px !important;
  color: #fff !important;
  /* font-weight: bolder; */
}

.viewer-navbar{
  height: 130px;
  background-color:rgba(0, 0, 0, 0.7) !important
}

.viewer-navbar .viewer-list{
  height: 130px;
}

.viewer-list > li{
  height: 130px !important;
  width: 100px !important;
  opacity:0.3 !important;
}

.viewer-list > .viewer-active, .viewer-list > .viewer-active:hover{
  opacity:1 !important;
}

@font-face {
    font-family: 'dbk';
    src: url('/data/zyk/upload/fonts/20171226DBK18.0.ttf') format('ttf');
}

</style>
